export const DeliveryCheckerEvents = {
  DELIVERY_SLOTS_CHECKER_SERVICES_CHANGED:
    "DELIVERY_SLOTS_CHECKER:SERVICES_CHANGED",
  DELIVERY_CHECKER_CHECK_PRESSED: "DELIVERY_CHECKER_CHECK_PRESSED",
  DELIVERY_CHECKER_RESULTS_DISPLAYED: "DELIVERY_CHECKER_RESULTS_DISPLAYED",
};
export type ServicesChangedEvent = {
  selectedDmsIds: string[];
};
